import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/core/actions/dropdown-menu";
import { Button } from "@/components/core/buttons/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/core/tabs.tsx";
import Tooltip from "@/components/core/tooltip";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { ProfileCaseList } from "@/features/new-case-ui/profile-case-list";
import { IconAwardFilled, IconDots, IconScale } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_backoffice/public-profile")({
	component: Page,
});

function Page() {
	return (
		<Content pageName="Cases">
			{/*<Header title="Cases" />*/}
			<div className="flex flex-col w-full max-w-base p-6 gap-6">
				<div className="relative flex flex-row items-center w-full p-8 rounded-md border border-border/50">
					<div className="flex flex-row items-center w-full gap-4">
						<div className="inline-flex justify-center items-center w-[80px] h-[80px] rounded-full bg-primary-600 text-primary-foreground">
							<IconScale size={32} stroke={2} />
						</div>
						<div className="inline-flex flex-col w-auto">
							<div className="inline-flex flex-row items-center w-auto gap-1">
								<span className="font-bold text-xl text-foreground-dark">Atty. Juan Dela Cruz</span>
								<Tooltip content="Bar Top-notcher 1950">
									<div className="inline-flex text-yellow-600">
										<IconAwardFilled size={20} stroke={2} />
									</div>
								</Tooltip>
							</div>
							<span className="text-base text-foreground/70">juandelacruz@email.com</span>
							<span className="text-base text-foreground/70">Role No. 931209</span>
						</div>
					</div>
					<div className="absolute top-4 right-4 inline-flex self-start shrink-0 flex-row w-auto ml-auto gap-2">
						<DropdownMenu modal={false}>
							<DropdownMenuTrigger asChild>
								<Button className="!rounded-full" type="button" size="icon" variant="ghost">
									<IconDots size={14} stroke={2} />
								</Button>
							</DropdownMenuTrigger>
							<DropdownMenuContent>
								<DropdownMenuGroup>
									<DropdownMenuItem onSelect={() => alert(1)}>
										<div className="flex flex-row items-center w-full py-1 px-2 gap-1">
											<span className="inline-flex">Some Action</span>
										</div>
									</DropdownMenuItem>
									<DropdownMenuItem onSelect={() => alert(1)}>
										<div className="flex flex-row items-center w-full py-1 px-2 gap-1">
											<span className="inline-flex">Another Action</span>
										</div>
									</DropdownMenuItem>
									<DropdownMenuItem onSelect={() => alert(1)}>
										<div className="flex flex-row items-center w-full py-1 px-2 gap-1">
											<span className="inline-flex">More Actions</span>
										</div>
									</DropdownMenuItem>
									<DropdownMenuSeparator />
									<DropdownMenuItem onSelect={() => alert(1)} dangerZone>
										<div className="flex flex-row items-center w-full py-1 px-2 gap-1">
											<span className="inline-flex">Danger Zone</span>
										</div>
									</DropdownMenuItem>
								</DropdownMenuGroup>
							</DropdownMenuContent>
						</DropdownMenu>
					</div>
				</div>

				<div className="flex flex-col w-full gap-4">
					<Tabs defaultValue="all-cases">
						<TabsList>
							<TabsTrigger value="all-cases">All Cases Involved</TabsTrigger>
							<TabsTrigger value="ongoing-cases">Active Cases Involved</TabsTrigger>
							<TabsTrigger value="closed-cases">Closed Cases Involved</TabsTrigger>
						</TabsList>
						<TabsContent value="all-cases">
							<ProfileCaseList />
						</TabsContent>
						<TabsContent value="ongoing-cases">
							<ProfileCaseList />
						</TabsContent>
						<TabsContent value="closed-cases">
							<ProfileCaseList />
						</TabsContent>
					</Tabs>
				</div>
			</div>
		</Content>
	);
}
